import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

class LogoutLoader extends React.Component {
  state = {
    modal: true,
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  render() {
    const { msg } = this.props;

    return (
      <div>
        <Modal isOpen={true} toggle={this.toggle}>
          <ModalBody>
            <div className="text-center ">
              <br />
              <span className="spinner-border text-primary"></span>
            </div>
            <br />
            <h3 className="text-center">{msg ? msg : ""}</h3>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default LogoutLoader;
